import { useLazyQuery } from "@apollo/client";
import { GET_PROJECTS } from "../../graphql/queries/ProjectContext";

// eslint-disable-next-line import/prefer-default-export
export const useGetProjects = () => {
  const [getProjects, { data, error, loading }] = useLazyQuery(GET_PROJECTS);

  return [getProjects, { data, error, loading }];
};
